export type PhotoPresentationLayout =
  | 'center'
  | 'fullWidth'
  | 'pageWidth'

  // New
  | 'monogram'
  | 'noPhoto'
  | 'photoArch'
  | 'photoBackground'
  | 'photoDuoLeft'
  | 'photoDuoRight'
  | 'photoMarquee'
  | 'photoSlider'
  | 'photoTrio'
  | 'photoTrioPageWidth';

export type SinglePhotoPresentationLayout = Extract<PhotoPresentationLayout, 'center' | 'fullWidth' | 'pageWidth'>;

export type AspectRatio =
  | number
  | number[]
  // This means the aspect ratio is fixed and should not change
  // only can change alignment of photo
  | 'locked'

  // This means the cropping can be freeform
  | null;

export type PhotoPresentationConfig = Record<
  PhotoPresentationLayout,
  {
    min: number;
    max: number;

    aspectRatio: AspectRatio;

    aloha?: {
      aspectRatio: AspectRatio;
    };

    brannan?: {
      aspectRatio: AspectRatio;
    };
  }
>;

export const PHOTO_PRESENTATION_CONFIG: PhotoPresentationConfig = {
  center: {
    min: 1,
    max: 1,

    // only can change alignment of photo
    aspectRatio: 'locked', // This means the aspect ratio is fixed and should not change
  },
  fullWidth: {
    min: 1,
    max: 1,

    aspectRatio: 21 / 9,
  },
  pageWidth: {
    min: 1,
    max: 1,

    aspectRatio: 16 / 9,
  },
  photoArch: {
    min: 1,
    max: 1,

    aspectRatio: 9 / 7,
  },
  photoBackground: {
    min: 1,
    max: 1,

    aspectRatio: 3 / 2,
  },

  // multi photo
  photoSlider: {
    min: 2,
    max: 6,
    aspectRatio: 12 / 7,

    aloha: {
      aspectRatio: 1 / 1,
    },

    brannan: {
      aspectRatio: 12 / 7,
    },
  },
  photoMarquee: {
    min: 4,
    max: 6,

    aspectRatio: null,
  },
  photoTrio: {
    min: 1,
    max: 3,

    aspectRatio: 6 / 9,
  },
  photoTrioPageWidth: {
    min: 1,
    max: 3,

    aspectRatio: 6 / 9,
  },
  photoDuoLeft: {
    min: 2,
    max: 2,

    aspectRatio: [7 / 5, 5 / 7],
  },
  photoDuoRight: {
    min: 2,
    max: 2,

    aspectRatio: [5 / 7, 7 / 5],
  },
  monogram: {
    min: 0,
    max: 0,

    aspectRatio: null,
  },
  noPhoto: {
    min: 0,
    max: 0,

    aspectRatio: null,
  },
};
